import { Environment } from '../environments';
import { buildUri } from './utils/buildUri';

const BIW_API_ROOT_URI_PARAMETERIZED = 'https://(env.)api.biw.cloud';

export const buildBiwApiRootUri = ( env ) => {
    let envParam = env;
    if ( env === Environment.LOCAL ) {
        envParam = Environment.QA;
    }

    return buildUri(
        BIW_API_ROOT_URI_PARAMETERIZED,
        { env: ( envParam !== Environment.PROD ) ? envParam : '' },
    );
};
